import {Model} from '@vuex-orm/core';

export default class BalanceModel extends Model {

    static entity = 'balance';
    static primaryKey = 'id_balance';

    static fields() {
        return {
            id_balance: this.number(null),
            id_user: this.number(null),
            type: this.attr(null),
            category: this.number(null),
            transfer_at: this.attr(null),
            amount: this.attr(null),
            notice: this.attr(null),
        };
    }

    get TypeString() {
        switch (this.type) {
            case 0:
                return "spending";
            case 1:
                return "income";
        }
        return null;
    }
}